module.exports = __webpack_public_path__ + "static/media/cansancio-no-dormir.a95b3e72.jpg";